import { useState, useRef, useEffect } from "react";

interface CardTooltipProps {
  card: Scryfall.Card;
  children: React.ReactNode;
}

function getCardImage(card: Scryfall.Card): string | null {
  if (card.image_uris?.small) return card.image_uris.small;
  if (card.card_faces?.[0]?.image_uris?.small)
    return card.card_faces[0].image_uris.small;
  return null;
}

export function CardTooltip({ card, children }: CardTooltipProps) {
  const [show, setShow] = useState(false);
  const [position, setPosition] = useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const triggerRef = useRef<HTMLSpanElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const imageUrl = getCardImage(card);

  useEffect(() => {
    if (show && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        x: rect.left + rect.width / 2,
        y: rect.top,
      });
    }
  }, [show]);

  if (!imageUrl) {
    return <>{children}</>;
  }

  return (
    <>
      <span
        ref={triggerRef}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        style={{ cursor: "pointer" }}
      >
        {children}
      </span>
      {show && (
        <div
          ref={tooltipRef}
          style={{
            position: "fixed",
            left: `${position.x}px`,
            top: `${position.y - 8}px`,
            transform: "translate(-50%, -100%)",
            zIndex: 9999,
            pointerEvents: "none",
          }}
        >
          <div className="bg-popover rounded-lg shadow-xl border border-border overflow-hidden">
            <img
              src={imageUrl}
              alt={card.name}
              className="block"
              style={{ width: "146px", height: "204px" }}
            />
          </div>
        </div>
      )}
    </>
  );
}
